///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot = abcsetup.thoughtspot || {};
abcsetup.thoughtspot.create = abcsetup.thoughtspot.create || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot.create = {
    init: function() {
        abcsetup.setTitle(abcsetup.userRole === 'thoughtspot_team' ? 'Create a ThoughtSpot Event' : 'Create an Event');

        abcsetup.thoughtspot.common.init();
    },

    /**
     * fieldError callback from _jquery.fieldValidate
     */
    fieldError: function() {
        var errorField = $('form').find('.invalid').first();
        console.log(errorField.parent().html());
        abcsetup.unblockUI();
    },
}
